module.exports = __webpack_public_path__ + "static/img/7.8892022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/7.jpg
// module id = wJnT
// module chunks = 1